const NEW_FREE_PLAN_TEST_GROUP_CONTRIES = [
  'Vietnam',
  'Singapore',
  'Netherlands',
  'Taiwan',
  'Germany',
  'Italy',
  'Philippines',
  'Spain',
  'Malaysia',
  'Mexico',
  'Uzbekistan',
  // add more countries for test group here
]
const NEW_FREE_PLAN_LIMIT = 15

const isTestNewFreePlan = (state) => {
  if (!state || state && !state.currentUser) return false
  return NEW_FREE_PLAN_TEST_GROUP_CONTRIES.includes(state.currentUser.country)
}
const planLimit = (state) => {
  if (state.currentUser.plan === 'free') {
    return NEW_FREE_PLAN_LIMIT
  }
  return state.plan.limit
}

export default {
  planLimit,
  isTestNewFreePlan,
}
